import { type FC } from "react";

import { AppLogo } from "~/components/AppLogo";

import { NEWSLETTER_DESCRIPTION, NEWSLETTER_HEADING } from "../../constants";
import { FooterSignUpForm } from "../FooterSignUpForm";
import * as Styled from "./FooterNewsletter.styles";

export const FooterNewsletter: FC = () => {
  return (
    <Styled.Root>
      <Styled.LogoWrapper>
        <AppLogo isSmall />
      </Styled.LogoWrapper>
      <Styled.Heading component="p">{NEWSLETTER_HEADING}</Styled.Heading>
      <Styled.FormWrapper>
        <FooterSignUpForm />
      </Styled.FormWrapper>
      <Styled.Description component="p">
        {NEWSLETTER_DESCRIPTION}
      </Styled.Description>
    </Styled.Root>
  );
};
